<form [formGroup]="companyForm">
  <div class="infobox yellow">
    <img src="assets/icons/shield-fill-exclamation.svg" alt="warning">
    <p>These settings can only be viewed and edited by Superadmins.</p>
  </div>

  <!-- Payment details section -->
  <div class="row">
    <section class="parentlabel" style="align-self: flex-start;">
      <h4>
        Parent label
      </h4>
      <p>
        When you set a parent label, the parent can act for this account and will automatically collect the remuneration
        as a default.
      </p>

      <div class="t-c">
        <div class="toggle-row" [style.cursor]="isDefaultBoard ? 'not-allowed' : 'pointer'" 
             [style.opacity]="isDefaultBoard ? '0.5' : '1'" 
             (click)="!isDefaultBoard && toggleSetParentLabel()">
          <div class="toggle-switch">
            <input type="checkbox" id="parent" formControlName="setParentLabel" [disabled]="isDefaultBoard">
            <span class="ts"></span>
          </div>
          <label class="right" for="parent" 
                 [style.cursor]="isDefaultBoard ? 'not-allowed' : 'pointer'" 
                 (click)="!isDefaultBoard && toggleSetParentLabel()">Set another label as parent</label>
        </div>
        <p *ngIf="isDefaultBoard" style="color: #666; font-size: 0.9rem; margin-top: 0.5rem;">
          This board cannot have a parent label as it is a root organization.
        </p>
      </div>

      <div class="input" *ngIf="companyForm.get('setParentLabel')?.value && !isDefaultBoard">
        <label for="parentLabel">Select label</label>
        <input type="text" id="parentLabel" list="labelselection" formControlName="parentBoardId"
          placeholder="Start typing to search..." autocomplete="off" style="width: 100%;"
          [class.error]="companyForm.get('parentBoardId')?.invalid && companyForm.get('parentBoardId')?.touched">

        <datalist id="labelselection">
          <option value="" selected>No parent</option>
          <option *ngFor="let parent of parentLabels" [attr.data-value]="parent.boardId">
            {{ parent.rightsholderName }}
          </option>
        </datalist>

        <span id="parentLabelError" class="error-message" *ngIf="companyForm.get('parentBoardId')?.invalid && companyForm.get('parentBoardId')?.touched">Please select a valid label from the list</span>
      </div>


    </section>
    <section class="paymentdetails" style="align-self: flex-start;">
      <h4>Payment Details</h4>
      <p>
        Choose whether the company collects remuneration directly or select a representative company. Then,
        update the payment details in the box below, ensuring accuracy, as this information is shared across multiple
        systems.
      </p>
      <div class="toggles">
        <div class="t-c">
          <div class="toggle-row" (click)="toggleCollectDirectly()" style="cursor: pointer;">
            <div class="toggle-switch">
              <input type="checkbox" formControlName="collectDirectly" (click)="$event.stopPropagation()">
              <span class="ts"></span>
            </div>
            <label class="right">Collect directly</label>
          </div>
        </div>
        <div class="t-c" *ngIf="Denmark && organizationId == 1 && companyForm.get('collectDirectly')?.value" style="margin-left: 0.5rem;">
          <div class="toggle-row" (click)="toggleUseNemkonto()" style="cursor: pointer;">
            <div class="toggle-switch">
              <input type="checkbox" formControlName="useNemkonto" (click)="$event.stopPropagation()">
              <span class="ts"></span>
            </div>
            <label class="right">Use NemKonto</label>
          </div>
        </div>

        <div class="t-c" *ngIf="!companyForm.get('collectDirectly')?.value && companyForm.get('collectorId')?.value">
          <div class="parentcollector">
            The remuneration is sent to <b>{{ companyForm.get('collectorId')?.value }}</b>
          </div>
        </div>



        <!-- Account Number fields - shown only when collecting directly -->
        <div class="row" id="payment-fields-no" *ngIf="companyForm.get('collectDirectly')?.value">
          <!-- For Norway -->
          <div class="input" *ngIf="Norway && organizationId == 2">
            <label>Account Number</label>
            <input formControlName="nO_AccountNo" class="inputformat-no" data-format="norwegian-account" maxlength="14"
              type="text" (input)="formatNorwegianAccountNumber($event)" placeholder="1111 22 33334">
          </div>

          <!-- For Denmark - Show input OR NemKonto message -->
          <div *ngIf="Denmark && organizationId == 1">
            <!-- Show input fields when NOT using NemKonto -->
            <div *ngIf="!companyForm.get('useNemkonto')?.value">
              <div class="row">
                <div class="input">
                  <label>Registration Number</label>
                  <input formControlName="dK_RegNo" type="text" placeholder="Enter registration number">
                </div>

                <div class="input">
                  <label>Account Number</label>
                  <input formControlName="dK_AccountNo" type="text" placeholder="Enter account number">
                </div>
              </div>
            </div>

            <!-- Show green infobox when using NemKonto AND VAT ID exists -->
            <div class="infobox green" *ngIf="companyForm.get('useNemkonto')?.value && companyInfo.vatid">
              <p>Transfers will be done to {{ companyInfo.vatid }}</p>
            </div>

            <!-- Show red warning when using NemKonto BUT no VAT ID -->
            <div class="infobox red" *ngIf="companyForm.get('useNemkonto')?.value && !companyInfo.vatid">
              <p><strong>NO VAT ID is connected!</strong></p>
            </div>
          </div>

          <!-- For other countries - International banking fields -->
          <div class="input" *ngIf="!Denmark && !Norway || (Denmark && organizationId === 2) || (Norway && organizationId === 1)">
            <label>Name of Bank</label>
            <input formControlName="intl_NameOfBank" type="text" placeholder="Enter bank name">
          </div>

          <div class="input" *ngIf="(!Denmark && !Norway) || (Denmark && organizationId == 2) || (Norway && organizationId == 1)">
            <label>IBAN</label>
            <input formControlName="intl_IBAN" type="text" placeholder="Enter IBAN">
          </div>


          <div class="input" *ngIf="(!Denmark && !Norway) || (Denmark && organizationId == 2) || (Norway && organizationId == 1)">
            <label>Swift/BIC</label>
            <input formControlName="intl_Swicfbic" type="text" placeholder="Enter Swift/BIC code">
          </div>

        </div>
      </div>
    </section>
  </div>

  <hr class="dashed">

  <!-- Type of company section -->
  <div class="row">
    <section class="typeofcompany">
      <div class="h">
        <h4>Type of company</h4>
        <p>There are two types of companies: labels, which act as repertoire owners and can claim tracks, and
          agents, who represent repertoire owners but cannot assign tracks to their own agency.</p>
      </div>
      <div class="row">
        <div class="input">
          <select id="dropdown" formControlName="memberType">
           <option value="Member">Member</option>
           <option value="Rightsholder">Rightsholder</option>
          </select>
        </div>
      </div>
    </section>

    <section class="membertype">
      <div class="h">
        <h4>Membertype</h4>
        <p>There are two types of companies: labels, which act as repertoire owners and can claim tracks, and
          agents, who represent repertoire owners but cannot assign tracks to their own agency.</p>
      </div>
      <div class="row">
        <div class="input">
          <select id="dropdown" formControlName="labelType">
            <option value="Label">Label</option>
            <option value="Agent">Agent</option>
          </select>
        </div>
      </div>
    </section>
  </div>

  <hr class="dashed">

  <!-- Status section -->
  <div class="row">
    <section class="status">
      <div class="h">
        <h4>Status</h4>
        <p>Labels are typically active, but in rare cases, deactivation is necessary. A deactivated label will
          prevent associated users from signing in but will be retained for potential future reactivation.</p>
      </div>
      <div class="row">
        <div class="input">
          <select id="dropdown" formControlName="isActive">
            <option [ngValue]="true">Active</option>
            <option [ngValue]="false">Inactive</option>
          </select>
        </div>
      </div>
    </section>

    <section class="internalfinancialidentifier">
      <div class="h">
        <h4>Limit access to Unclaimed Repertoire</h4>
        <p>This will restrict the accessible repertoire in Search & Assign, as well as in reports and downloads,
          to only those reports that have been processed at least once.</p>
      </div>
      <div class="t-c">
        <div class="toggle-row" (click)="toggleAccessLevel()" style="cursor: pointer;">
          <div class="toggle-switch">
            <input type="checkbox" formControlName="companyAccessLevel" />
            <span class="ts"></span>
          </div>
          <label class="right">Set access to Unclaimed Repertoire-only</label>
        </div>
      </div>
    </section>
  </div>

  <hr class="dashed">

  <!-- Memberships section -->
  <div class="row">
    <section class="status">
      <div class="h">
        <h4>Memberships</h4>
        <p>The organization is important for both analytical purposes and potential deductions in distributions.</p>
      </div>
      <div class="row">
        <div class="toggles">
          <div class="t-c" *ngIf="organizationId === 2">
            <div class="toggle-row" (click)="toggleIfpiNorge()" style="cursor: pointer;">
              <div class="toggle-switch">
                <input type="checkbox" formControlName="ifpiNorge" (click)="$event.stopPropagation()" />
                <span class="ts"></span>
              </div>
              <label class="right">IFPI Norge</label>
            </div>
          </div>
          <div class="t-c" *ngIf="organizationId === 2">
            <div class="toggle-row" (click)="toggleFono()" style="cursor: pointer;">
              <div class="toggle-switch">
                <input type="checkbox" formControlName="fono" (click)="$event.stopPropagation()" />
                <span class="ts"></span>
              </div>
              <label class="right">FONO</label>
            </div>
          </div>
          <div class="t-c" *ngIf="organizationId === 1  ">
            <div class="toggle-row" (click)="toggleIfpiDanmark()" style="cursor: pointer;">
              <div class="toggle-switch">
                <input type="checkbox" formControlName="ifpiDanmark" (click)="$event.stopPropagation()" />
                <span class="ts"></span>
              </div>
              <label class="right">IFPI Danmark</label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="deletecompany">
      <h4>Delete company</h4>
      <p>This action is irreversible. It is generally recommended to only deactivate a label instead.</p>
      <button type="button" class="btn red">Delete company</button>
    </section> -->
  </div>
</form>

<div class="unsaved-changes-alert" *ngIf="companyForm.dirty" [ngClass]="animationState">
  <p class="fw-bold mb-0">You have unsaved changes!</p>
  <button class="btn discardbtn" (click)="cancel()">Discard changes</button>
  <button class="btn green" (click)="UpdateCompany()">Save changes</button>
</div>